import React from "react";
import { motion } from 'framer-motion';
import ThanksImage1 from '../../assets/images/thanks1.svg';
import SeparatorWave from '../../assets/images/separator_wave.svg';
import inspiraLogo from '../../assets/images/inspira_logo.png';
import TestimonialImage1 from '../../assets/images/testimonial1.svg';
import TestimonialImage2 from '../../assets/images/testimonial2.svg';
import TestimonialImage3 from '../../assets/images/testimonial3.svg';


export default function TestimonialsSection({ id }) {
    return (
        <motion.div>
            <div id={id} className="bg-white flex flex-col items-center w-full mx-auto p-10 pt-0 pb-0 lg:py-0 scroll-mt-36 font-lato overflow-hidden">
                <div className='container mx-auto text-center'>
                    <motion.img
                        src={inspiraLogo}
                        alt="Inspira Logo"
                        className="w-1/12 h-auto mx-auto"
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        viewport={{ amount: 0.9, once: true }}
                        transition={{ type: 'spring', stiffness: 70 }}
                    />
                    <img
                        src={ThanksImage1}
                        alt="Defendamos"
                        className="lg:w-5/12 h-auto mx-auto"
                    />
                </div>
            </div>
            <div className="w-full relative">
                <img
                    src={SeparatorWave}
                    alt="Separador ola azul"
                    className="w-full h-auto absolute
                    md:top-[-9px]
                    top-[50px] left-0
                    lg:top-[-105px] lg:left-0"
                />
            </div>
            <div className="bg-idarkblue lg:p-0 w-full flex flex-col lg:flex-row items-center justify-center mx-auto mt-28 p-10 h-auto lg:h-72 gap-4">
                <img
                    src={TestimonialImage1}
                    alt="Inspira Logo"
                    className="w-6/12 lg:w-3/12 h-auto self-start lg:self-center"
                />
                <img
                    src={TestimonialImage2}
                    alt="Inspira Logo"
                    className="w-6/12 lg:w-3/12 h-auto self-end lg:self-center"
                />
                <img
                    src={TestimonialImage3}
                    alt="Inspira Logo"
                    className="w-6/12 lg:w-3/12 h-auto self-start lg:self-center"
                />
            </div>

        </motion.div >
    );
}

